module.exports = __webpack_public_path__ + "img/badge_fair_silver.7071e6a3.png";